import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ServerAlertEnum } from '@whelk/services/src/common';

const initialState = {
  serverAlertStatus: 0 as ServerAlertEnum,

  softKeyboardOpen: false,
  selectedChatLoading: false,
  contactPageOpen: false,

  showScreenShotResult: false,
  screenShotLoading: false, // 是否加载中。因为截图是异步的，所以需要一个状态来控制
  screenShotDataUrl: '',

  isUserTriggeredChatListHeightChange: false, // 是否是用户操作（例如文件列表展开收起）导致的聊天列表dom高度变化
  chatScene: 0 as number, // 聊天场景
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setSoftKeyboardOpen: (state, action: PayloadAction<boolean>) => {
      state.softKeyboardOpen = action.payload;
    },
    setContactPageOpen: (state, action: PayloadAction<boolean>) => {
      state.contactPageOpen = action.payload;
    },
    setSelectedChatLoading: (state, action: PayloadAction<boolean>) => {
      state.selectedChatLoading = action.payload;
    },
    setServerAlertStatus: (state, action: PayloadAction<ServerAlertEnum>) => {
      state.serverAlertStatus = action.payload;
    },
    setScreenShotLoading: (state, action: PayloadAction<boolean>) => {
      state.screenShotLoading = action.payload;
    },
    openScreenShotResultModal: (state, action: PayloadAction<string>) => {
      state.screenShotDataUrl = action.payload;
      state.showScreenShotResult = true;
    },
    closeScreenShotResultModal: (state) => {
      state.showScreenShotResult = false;
    },
    setChatScene: (state, action: PayloadAction<number>) => {
      state.chatScene = action.payload;
    },
    setIsUserTriggeredChatListHeightChange: (state, action: PayloadAction<boolean>) => {
      state.isUserTriggeredChatListHeightChange = action.payload;
    },
  },
});

export const {
  setChatScene,
  setContactPageOpen,
  setSoftKeyboardOpen,
  setServerAlertStatus,
  setSelectedChatLoading,
  setScreenShotLoading,
  openScreenShotResultModal,
  closeScreenShotResultModal,
  setIsUserTriggeredChatListHeightChange,
} = layoutSlice.actions;

export default layoutSlice.reducer;
